import EBarAdminCase from './EBarAdminCase';

export default EBarAdminCase;
